import { type RefObject, useEffect, useRef } from 'react';

import type { SwimlaneApi, SwimlanePrivateApi } from './types';

export function useSwimlaneApiMethod<V extends 'public' | 'private'>(
  privateApiRef: RefObject<SwimlanePrivateApi>,
  apiMethods: V extends 'public' ? Partial<SwimlaneApi> : Partial<SwimlanePrivateApi>,
  visibility: V,
) {
  const isFirstRender = useRef(true);

  useEffect(() => {
    isFirstRender.current = false;
    privateApiRef.current.register(visibility, apiMethods);
  }, [privateApiRef, visibility, apiMethods]);

  if (isFirstRender.current) {
    privateApiRef.current.register(visibility, apiMethods);
  }
}
